import { graphql } from '../gql';

/** The WhatsApp log for the month's bills (statuses change via Meta's webhook). */
export const MonthWhatsappDocument = graphql(`
  query MonthWhatsapp($start: Date!, $end: Date!) {
    whatsappMessages(
      filter: {
        bill: { billMonth: { greaterThanOrEqualTo: $start, lessThanOrEqualTo: $end } }
      }
      orderBy: [CREATED_AT_DESC]
    ) {
      nodes {
        id
        status
        error
        createdAt
        billId
        toPhone
        member {
          fullName
        }
      }
    }
  }
`);
